import React, { useState, useEffect } from 'react';

import BigIntegerTextField from '../component/BigIntegerTextField';
import EthereumAddressTextField from '../component/EthereumAddressTextField';
import FieldSetFormControl from '../component/FieldSetFormControl';
import HashTextField from '../component/HashTextField';
import HexStringTextField from '../component/HexStringTextField';

import Box from "@material-ui/core/Box";
import Checkbox from "@material-ui/core/Checkbox";
import Divider from "@material-ui/core/Divider";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";

import BN from 'bn.js';
import { ethers } from 'ethers';

function toHexString (x) {
  x = x.trim ().toLowerCase ();
  if (!x) throw new Error ("Value is empty");
  const xBN = x.startsWith ('0x') ? new BN (x.substring (2), 16) :
      x.startsWith ('0b') ? new BN (x.substring (2), 2) :
      new BN (x);
  if (xBN.eq (new BN ('0'))) return '0x';
  else return ethers.utils.hexlify ('0x' + xBN.toString (16));
}

function ContractAddress (props) {
  const {
    ...other
  } = props;

  const [ address, setAddress ] = useState ('');
  const [ nonce, setNonce ] = useState ('0');
  const [ create2, setCreate2 ] = useState (false);
  const [ initCodeVariant, setInitCodeVariant ] = useState ('code');
  const [ initCode, setInitCode ] = useState ('');
  const [ initCodeHash, setInitCodeHash ] = useState ('');
  const [ contractAddress, setContractAddress ] = useState ('');

  useEffect (() => {
    if (initCodeVariant === 'code') {
      try {
        const trimmedInitCode = initCode.trim ();
        const lowerCaseInitCode = trimmedInitCode.toLowerCase ();
        if (!lowerCaseInitCode.match (/^0x([0-9a-f]{2})*$/))
          throw new Error ("Invalid init code");
        setInitCodeHash (ethers.utils.keccak256 (lowerCaseInitCode));
      } catch (error) {
        setInitCodeHash ('');
      }
    }
  }, [ initCodeVariant, initCode ]);

  useEffect (() => {
    try {
      if (address.trim ().length !== 42) throw new Error ('Invalid address');
      if (create2) {
        if (initCodeHash.trim ().length !== 66)  throw new Error ('Invalid init code hash');
        setContractAddress (
          ethers.utils.getAddress (
            '0x' +
            ethers.utils.keccak256 (
              ethers.utils.concat ([
                '0xff',
                address.trim (),
                ethers.utils.padZeros (toHexString (nonce), 32),
                initCodeHash.trim ()
              ])).substring (26)));
      } else {
        setContractAddress (
          ethers.utils.getAddress (
            '0x' + 
            ethers.utils.keccak256 (
              ethers.utils.RLP.encode (
                [
                  address.trim (),
                  toHexString (nonce)
                ])).substring (26)));
      }
    } catch (error) {
      setContractAddress ('');
    }
  }, [ address, nonce, create2, initCodeVariant, initCodeHash ]);

  return (
    <Box my={-1}
         component={FieldSetFormControl}
         fullWidth
         {...other}>
      <Box my={1}
           component={EthereumAddressTextField}
           label="Creator's address"
           value={address}
           onChange={event => setAddress (event.target.value)} />
      <Box my={1}
           component={BigIntegerTextField}
           label="Nonce / salt"
           validator={bn => bn.bitLength () > 256 && 'Value too big'}
           value={nonce}
           onChange={event => setNonce (event.target.value)} />
      <Box mb={2}
           component={RadioGroup}
           row
           value={initCodeVariant}
           onChange={event => setInitCodeVariant (event.target.value)}>
        <FormControlLabel label="CREATE2"
                        control={
                          <Checkbox checked={create2}
                                    onChange={event => setCreate2 (event.target.checked)}/>
                        } />
        <FormControlLabel label="Code"
                          control={<Radio disabled={!create2} />}
                          value="code" />
        <FormControlLabel label="Hash"
                          control={<Radio disabled={!create2} />}
                          value="hash" />
      </Box>
      <Box my={1}
           component={HexStringTextField}
           label="Init code"
           disabled={!create2 || initCodeVariant !== 'code'}
           value={initCode}
           onChange={event => setInitCode (event.target.value)} />
      <Box my={1}
           component={HashTextField}
           label="Init code hash"
           disabled={!create2}
           readOnly={initCodeVariant !== 'hash'}
           value={initCodeHash}
           onChange={event => setInitCodeHash (event.target.value)} />
      <Box mt={1}
           mb={3}>
        <Divider />
      </Box>
      <Box my={1}
           component={EthereumAddressTextField}
           label="Contract address"
           readOnly={true}
           value={contractAddress} />
    </Box>
  );
}

export default ContractAddress;
